import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

interface UWReviewSkeletonProps {
  titleFontSize?: number;
  imageSize?: number;
}

export function UWReviewSkeleton({
  titleFontSize = 32,
  imageSize = 160,
}: UWReviewSkeletonProps) {
  return (
    <Stack data-testid="uw-review-loading" aria-busy="true" spacing={2}>
      <Skeleton variant="circular" width={imageSize} height={imageSize} />
      <Skeleton variant="text" width={360} sx={{ fontSize: titleFontSize }} />
      <Skeleton variant="text" width={220} />
      <Skeleton variant="text" width={220} />
      <Skeleton variant="text" width={140} />
      <Skeleton variant="text" width="80%" />
      <Skeleton variant="text" width="70%" />
    </Stack>
  );
}
